import { render, staticRenderFns } from "./AcaoObjetoEdit.vue?vue&type=template&id=d49468ec&scoped=true"
import script from "./AcaoObjetoEdit.vue?vue&type=script&lang=js"
export * from "./AcaoObjetoEdit.vue?vue&type=script&lang=js"
import style0 from "./AcaoObjetoEdit.vue?vue&type=style&index=0&id=d49468ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d49468ec",
  null
  
)

export default component.exports